import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import StickyConsultationButton from '../../components/feature/StickyConsultationButton';
import HeroSection from './components/HeroSection';
import StepFlowSection from './components/StepFlowSection';
import TimelineSection from './components/TimelineSection';
import StatsSection from './components/StatsSection';
import PricingSection from './components/PricingSection';
import FounderSection from './components/FounderSection';
import FaqSection from './components/FaqSection';
import ComparisonSection from './components/ComparisonSection';
import FinalCtaSection from './components/FinalCtaSection';
import ServiceComparisonSection from './components/ServiceComparisonSection';
import PlanDiagnosisSection from './components/PlanDiagnosisSection';
import PlanCaseStudiesSection from './components/PlanCaseStudiesSection';
import ConsultationFormSection from './components/ConsultationFormSection';
import SeoLangSync from '../../components/feature/SeoLangSync';

export default function PricingPage() {
  return (
    <>
      <SeoLangSync
        title="料金プラン | 東京民泊運営代行 Magome Kominka"
        description="Magome Kominkaの民泊運営代行サービスの料金プランをご紹介。初期費用0円、成果報酬型の透明性の高い料金体系で、東京の民泊運営をサポートします。無料相談受付中。"
        keywords="民泊運営代行,料金,プラン,東京,馬込,品川区,初期費用,成果報酬"
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <HeroSection />
        <StepFlowSection />
        <TimelineSection />
        <StatsSection />
        <PricingSection />
        <ServiceComparisonSection />
        <PlanDiagnosisSection />
        <PlanCaseStudiesSection />
        <ConsultationFormSection />
        <FounderSection />
        <ComparisonSection />
        <FaqSection />
        <FinalCtaSection />
        <Footer />
        <StickyConsultationButton />
      </div>
    </>
  );
}
